<template>
    <div style="padding: 15px;height: 100vh">
        <div v-if="render_type != 'edit_user_admin'" class="app-content">
            <a-spin :spinning="loading">
                <a-card :title="title">
                    <template #extra>
                        <a-space>
                            <router-link :to="`/app/salaryAdmin/add`">
                                <a-button v-if="button_title" style="display: flex;"
                                    type="primary" size="large">
                                    <template #icon><span class="material-symbols-outlined">Add</span></template>
                                    สร้างข้อมูลเงินเดือน
                                </a-button>
                            </router-link>
                            <a-button v-if="button_title" style="display: flex;"
                                @click="show_month_report = true"
                                type="primary" size="large">
                                <img
                                src="https://img.icons8.com/?size=100&id=3NeB_j4SNg2G&format=png&color=000000"
                                alt="billAndDebt"
                                width="16"
                                height="16"
                                :style="{ margin: '0', filter: selected_billing?.billing_action_id != 1 ? 'invert(100%)' : 'invert(70%)' }"/>
                                ออกรายงานเงินเดือน
                            </a-button>
                        </a-space>
                    </template>

                    <a-row>
                        <a-space>
                            <a-input-search style="width: 300px;" v-model:value="search_input" :placeholder="`ค้นหา ชื่อพนักงานขับรถ`" enter-button="Search"/>
                            <a-range-picker v-model:value="timeStart" />
                        </a-space>
                        <a-button @click="clear_search" type="dashed" style="margin-left: 1rem">CLEAR</a-button>
                    </a-row>

                    <br>
                    <a-row>
                        <a-table :columns="filteredColumns" :data-source="filtered_list(salaryList)" bordered size="small" :scroll="{ x: 'calc(100px + 50%)', y: '100%' }">
                            <template #bodyCell="{ column, record }">
                                <template v-if="column.key === 'purchase_datetime'">
                                    <div> {{ render_date(record.purchase_datetime) }} - {{render_date(record.purchase_end_datetime)}} </div>
                                </template>
                                <template v-if="column.key === 'fullname'">
                                    <div> {{ record.fullname }} </div>
                                </template>
                                <template v-if="column.key === 'leave_other'">
                                    <div>
                                        {{ record.leave_summary
                                        .filter(item => ![4, 5, 6].includes(item.leave_type_id))
                                        .reduce((sum, item) => sum + item.count, 0) }}
                                    </div>
                                </template>
                                <template v-if="column.key === 'leave_sick'">
                                    <div> {{ record.leave_summary.find((item)=>[5].includes(item.leave_type_id))?.count||0 }} </div>
                                </template>
                                <template v-if="column.key === 'leave_business'">
                                    <div> {{ record.leave_summary.find((item)=>[4].includes(item.leave_type_id))?.count||0 }} </div>
                                </template>
                                <template v-if="column.key === 'leave_holiday'">
                                    <div> {{ record.leave_summary.find((item)=>[6].includes(item.leave_type_id))?.count||0 }} </div>
                                </template>
                                <template v-if="column.key === 'salary'">
                                    <div> {{ Number(record.salary).toLocaleString() }} </div>
                                </template>
                                <template v-if="column.key === 'leave_price'">
                                    <div> {{ Number(record.leave_price).toLocaleString() }} </div>
                                </template>
                                <template v-if="column.key === 'social_insurance_price'">
                                    <div> {{ Number(record.social_insurance_price).toLocaleString() }} </div>
                                </template>
                                <template v-if="column.key === 'other_cost_price'">
                                    <div> {{ Number(record.other_cost_price).toLocaleString() }} </div>
                                </template>
                                <template v-if="column.key === 'other_price'">
                                    <div> {{ Number(record.other_price).toLocaleString() }} </div>
                                </template>
                                <template v-if="column.key === 'total_price'">
                                    <div> {{ Number(record.total_price).toLocaleString() }} </div>
                                </template>
                                <template v-if="column.key === 'claim_status_id'">
                                    <span >
                                        <div v-if="statusCar(record) && isHexColor(statusCar(record).color)" :style="statusStyle(statusCar(record).color)">
                                        {{ statusCar(record).txt }}
                                        </div>
                                        <a-tag v-else-if="statusCar(record)" :color="statusCar(record).color">
                                        {{ statusCar(record).txt }}
                                        </a-tag>
                                    </span>
                                </template>
                                <template v-if="column.key === 'id'">
                                    <div>
                                        <a-tooltip>
                                        <template #title>อัพเดทข้อมูล</template>
                                        <a @click="show_update_progress(record.id)"
                                            ><span style="font-size: 14px" class="material-symbols-outlined"
                                            >update</span
                                            ></a
                                        >
                                        </a-tooltip>
                                        <a-divider type="vertical"></a-divider>
                                        <a-tooltip>
                                        <template #title>แก้ไข</template>
                                        <a @click="go_to_edit_salary(record.id)"
                                            ><span style="font-size: 14px" class="material-symbols-outlined"
                                            >drive_file_rename_outline</span
                                            ></a
                                        >
                                        </a-tooltip>
                                        <a-divider type="vertical"></a-divider>
                                        <a-tooltip>
                                        <template #title>ยกเลิก</template>
                                        <a @click="showDeleteModal(record.id,record)"
                                            ><span style="font-size: 18px" class="material-symbols-outlined"
                                            >delete</span
                                            ></a
                                        >
                                        </a-tooltip>
                                    </div>
                                </template>
                            </template>
                        </a-table>
                    </a-row>
                    <a-modal v-model:visible="showModalLeaveUserData" @ok="showModalLeaveUserData=false" >
                        <div style="display: flex; flex-direction: column ;justify-items:start;align-items: start">
                            <a-form-item label="ชื่อ-นามสกุล ผู้ส่งคำขอ" name="leave_user_no" style="width: 98%; margin-top: 5%;">
                                <a-input :value="selectedLeave.fullname" placeholder="ชื่อ-นามสกุล ผู้ส่งคำขอ" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="เลขกำกับใบเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="selectedLeave.withdraw_user_no" placeholder="เลขกำกับใบเบิก" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="วันที่แจ้งเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="render_date(selectedLeave.withdraw_user_timestamp)" placeholder="วันที่แจ้งเบิก" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="วันที่ขอเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="render_date(selectedLeave.time_start)" placeholder="วันที่ขอเบิก" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="ประเภทการเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="getLeavePatternTypeName(selectedLeave.claim_type_id)" placeholder="ประเภทการเบิก" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="จำนวนวันขอเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="selectedLeave.withdraw_user_amount" placeholder="จำนวนวันขอเบิก" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="ผลอนุมัติ" name="leave_user_no" style="width: 98%;">
                                <!-- <a-input :value="getApproveStatusName(selectedLeave.approve_status)" placeholder="การอนุมัติ"></a-input> -->
                                <a-select style="width: 100%;" placeholder="ผลอนุมัติ" v-model:value="selectedLeave.approve_status"
                                        @change="(value) => handleChangeApproveStatus(selectedLeave.id, value)">
                                        <a-select-option value=1>อนุมัติ</a-select-option>
                                        <a-select-option value=2>ไม่อนุมัติ</a-select-option>
                                    </a-select>
                            </a-form-item>
                            <a-form-item label="เหตุผลการขอเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="selectedLeave.withdraw_user_remark" placeholder="เหตุผลการขอเบิก" disabled></a-input>
                            </a-form-item>
                            <div>
                            <p>ใบรูปหลักฐานการโอน:</p>
                            <div v-if="selectedLeave.photo_1 != null && selectedLeave.photo_1 != ''" class="image-container" style="margin-top: -5px; margin-bottom: 15px;">
                                <img :src="selectedLeave.photo_1" class="uploaded-image-table" alt="uploaded image" />
                                <div class="icon-container">
                                    <span class="material-symbols-outlined preview-icon" @click="showPreview($event, selectedLeave.photo_1)">
                                        visibility
                                    </span>
                                    <span class="material-symbols-outlined download-icon"
                                        @click="getBase64Image($event, selectedLeave.photo_1)">
                                        download
                                    </span>
                                    <span class="material-symbols-outlined download-icon"
                                        @click="remove_uploaded_file">
                                        Delete
                                    </span>
                                </div>
                            </div>
                            <a-upload 
                                v-else
                                v-model:file-list="fileList"
                                list-type="picture-card"
                                class="avatar-uploader"
                                name="photo_1"
                                :action="upload_files"
                                accept="image/*"
                                method="GET"
                                :show-upload-list="false"
                                @remove="remove_uploaded_file">
                                <div style="height: 104px; width: 173px; padding: 2rem">
                                    <span style="font-size: 40px" class="material-symbols-outlined">upload_file</span>
                                    <div style="margin-top: 8px">คลิกเพื่ออัพโหลดรูปภาพ</div>
                                </div>
                            </a-upload>
                            </div>
                            <a-form-item label="หมายเหตุ" name="withdraw_admin_remark" style="width: 98%;">
                                <a-textarea v-model:value="selectedLeave.withdraw_admin_remark" placeholder="หมายเหตุ" :rows="3"></a-textarea>
                            </a-form-item>
                            <a-form-item label="ชื่อผู้อนุมัติการเบิก" name="approver" style="width: 98%; margin-top: 6%;">
                                <a-select style="width: 100%;" placeholder="ชื่อผู้อนุมัติ" v-model:value="selectedLeave.approver"
                                    @change="(value) => handleChangeApprover(selectedLeave.id, value)">
                                    <a-select-option
                                        v-for="({ fullname }, i) in administrative"
                                        :key="i"
                                        :value="fullname"
                                        >
                                        {{ fullname }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </div>
                        <template #footer>
                            <a-button type="primary" @click="submitWithdrawAdmin()">
                                ยืนยัน
                            </a-button>
                            <a-button @click="showModalLeaveUserData=false">
                                ปิด
                            </a-button>
                        </template> 
                    </a-modal> 
                    <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false"
                        class="custom-modal" style="background-color: none !important">
                        <img :src="previewImage" alt="Preview" style="width: 100%;" />
                    </a-modal>
                </a-card>
            </a-spin>
        </div>
        <a-modal
        v-model:visible="update_progress_modal"
        @ok="update_progress"
        >
            <template #title>
                เลือกสถานะการเบิกจ่ายเงิน
            </template>
            <a-card>
                <a-form :model="selectedSalary" layout="vertical">
                    <a-form-item label="สถานะการเบิกจ่ายเงิน">
                        <a-select v-model:value="status_modal_id" placeholder="เลือกสถานะการเบิกจ่ายเงิน">
                        <a-select-option
                            v-for="{ id, name } in claimStatusList"
                            :key="id"
                            :value="id"
                        >
                            {{ name }}
                        </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-form>
            </a-card>
        </a-modal>
        <a-modal v-model:visible="show_month_report" :title="'ออกรายงานเงินเดือน'" :footer="null">
          <a-form :model="month_report" layout="vertical" @finish="submit_month_report()">
            <a-row justify="center">
              <a-col :span="20">
                <a-form-item label="บริษัทรถ" :rules="[{ required: true, message: 'โปรดระบุบริษัทรถ' }]" name="car_company_id">
                    <a-select
                        v-model:value="month_report.car_company_id"
                        placeholder="เลือกบริษัทรถ"
                        style="width: 300px"
                        show-search
                    >
                        <a-select-option v-for="{fullname,id} in car_company_list" :value="id">{{fullname}}</a-select-option>
                    </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row justify="center">
              <a-col :span="20">
               <a-form-item label="ชื่อ-นามสกุลผู้ขับ" :rules="[{ required: true, message: 'โปรดระบุชื่อ-นามสกุลผู้ขับ' }]" name="driver_id">
                    <a-select
                        v-model:value="month_report.driver_id"
                        placeholder="เลือกชื่อ-นามสกุลผู้ขับ"
                        style="width: 300px"
                        show-search
                    >
                        <a-select-option v-for="{firstname,lastname,id} in driver_list" :value="id">{{firstname+' '+lastname}}</a-select-option>
                    </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row justify="center">
              <a-col :span="20">
               <a-form-item label="งวดเงินเดือนที่" :rules="[{ required: true, message: 'โปรดระบุงวดเงินเดือนที่' }]" name="month_period">
                    <a-select
                        v-model:value="month_report.month_period"
                        placeholder="เลือกงวดเงินเดือนที่"
                        style="width: 300px"
                        show-search
                    >
                        <a-select-option v-for=" valuePeriod in periodList" :value="valuePeriod">{{valuePeriod}}</a-select-option>
                    </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row justify="center">
              <a-col :span="20">
                <a-form-item label="วันที่ทำจ่าย" :rules="[{ required: true, message: 'โปรดระบุวันที่ทำจ่าย' }]" name="purchase_datetime">
                    <a-range-picker
                        v-model:value="month_report.purchase_datetime"
                        format="DD/MM/YYYY"
                        :placeholder="['Start Time', 'End Time']"
                        style="width: 300px;"
                    />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row justify="end">
                <a-button type="primary" html-type="submit">บันทึก</a-button>
            </a-row>
          </a-form>
        </a-modal>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
import SystemService from '../../api/SystemService'
import dayjs from 'dayjs'
import CompanyService from '../../api/CompanyService'
import UserService from '../../api/UserService';
import SalaryService from '../../api/SalaryService';
import DriverService from '../../api/DriverService';
import * as xlsx from "xlsx-js-style";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import axios from 'axios';

export default {
    name: 'salaryAdmin',
    data() {
        return {
            previewImage: "",
            previewVisible: false,
            businessTypeId:null,
            leave_user: [],
            salaryList: [],
            selectedLeave: {},
            showModalLeaveUserData: false,
            timeStart: null,
            timeEnd: null,
            leave_types: [],
            loading: false,
            search_business_type: null,
            business: false,
            leave_pattern_list:[
                {id: 1, name:'เงินสด'},
                {id: 2, name:'เงินโอน'},
            ],
            leave_quota_data: [], // ดึงข้อมูลโควตาจาก API
            img_placeholder: require('@/assets/images/place-holder/placeholder.jpg'),
            show_table_list: [],
            leave_types: [],
            operations: [],
            accounting: [],
            administrative: [],
            fileList: [],
            title: 'จัดการเงินเดือน',
            button_title: 'ประวัติการแจ้งเบิก',
            input: 'Username / ชื่อบริษัท',
            search_input: null,
            leaveStatus: [],
            update_progress_modal: false,
            claimStatusList: [],
            selectedSalary: null,
            status_modal_id: null,
            car_company_list:[],
            driver_list:[],
            periodList:[],
            month_report:[],
            show_month_report: false,
            columns: [
                {
                    title: 'งวดเงินเดือนที่',
                    dataIndex: 'month_period',
                    key: 'month_period',
                    width: 200,
                    align: 'center',
                },
                {
                    title: 'วันที่ทำจ่าย',
                    dataIndex: 'purchase_datetime',
                    key: 'purchase_datetime',
                    width: 200,
                    align: 'center',
                },
                {
                    title: 'ชื่อเล่น-ชื่อจริง',
                    dataIndex: 'fullname',
                    key: 'fullname',
                    width: 200,
                    align: 'center',
                },
                {
                    title: 'รหัสพนักงาน',
                    dataIndex: 'driver_no',
                    key: 'driver_no',
                    width: 200,
                    align: 'center',
                },
                {
                    title: 'ชื่อ',
                    dataIndex: 'firstname',
                    key: 'firstname',
                    width: 200,
                    align: 'center',
                },
                {
                    title: 'นามสกุล',
                    dataIndex: 'lastname',
                    key: 'lastname',
                    width: 200,
                    align: 'center',
                },
                {
                    title: 'เงินเดือน',
                    dataIndex: 'salary',
                    key: 'salary',
                    width: 200,
                    align: 'center',
                },{
                    title: 'ลาอื่นๆ',
                    dataIndex: 'leave_other',
                    key: 'leave_other',
                    width: 200,
                    align: 'center',
                },{
                    title: 'ลาป่วย',
                    dataIndex: 'leave_sick',
                    key: 'leave_sick',
                    width: 200,
                    align: 'center',
                },{
                    title: 'ลากิจ',
                    dataIndex: 'leave_business',
                    key: 'leave_business',
                    width: 200,
                    align: 'center',
                },{
                    title: 'ลาพักร้อน',
                    dataIndex: 'leave_holiday',
                    key: 'leave_holiday',
                    width: 200,
                    align: 'center',
                },{
                    title: 'หักลา',
                    dataIndex: 'leave_price',
                    key: 'leave_price',
                    width: 200,
                    align: 'center',
                },{
                    title: 'หักประกันสังคม',
                    dataIndex: 'social_insurance_price',
                    key: 'social_insurance_price',
                    width: 200,
                    align: 'center',
                },{
                    title: 'รายได้อื่นๆ',
                    dataIndex: 'other_cost_price',
                    key: 'other_cost_price',
                    width: 200,
                    align: 'center',
                },{
                    title: 'หักอื่นๆ',
                    dataIndex: 'other_price',
                    key: 'other_price',
                    width: 200,
                    align: 'center',
                },{
                    title: 'รายได้รวม',
                    dataIndex: 'total_price',
                    key: 'total_price',
                    width: 200,
                    align: 'center',
                },{
                    title: 'สถานะการเบิกจ่ายเงิน',
                    dataIndex: 'claim_status_id',
                    key: 'claim_status_id',
                    width: 200,
                    align: 'center',
                },
                {
                    title: 'ตัวเลือก',
                    dataIndex: 'id',
                    key: 'id',
                    width: 130,
                    align: 'center',
                    fixed: 'right'
                }
            ],
            incomeList : [
                { name: 'เงินเดือนค่าจ้าง (Salary)', price: 'driver_salary' },
                { name: 'หัวหน้าชุด (Leader)', price: 'set_leader' },
                { name: 'ดูแลรักษารถ (Take Car Care)', price: 'car_care_text' },
                { name: 'P SMART', price: 'p_smart' },
                { name: 'ค่าเที่ยวพิเศษ (Special)', price: 'special_trip_price' },
                { name: 'ค่าเที่ยว (20)', amount: 'amount_1', price: 'price_1' },
                { name: 'ค่าเที่ยว (25)', amount: 'amount_2', price: 'price_2' },
                { name: 'ค่าเที่ยว (30)', amount: 'amount_3', price: 'price_3' },
                { name: 'ค่าเที่ยว (35)', amount: 'amount_4', price: 'price_4' },
                { name: 'ค่าเที่ยว (40)', amount: 'amount_5', price: 'price_5' },
                { name: 'ค่าเที่ยว (50)', amount: 'amount_6', price: 'price_6' },
                { name: 'ค่าเที่ยว (60)', amount: 'amount_7', price: 'price_7' },
                { name: 'ค่าเที่ยว (80)', amount: 'amount_8', price: 'price_8' },
                { name: 'ค่าเที่ยววันหยุด (70)', amount: 'rest_amount', price: 'rest_price' },
                { name: 'ค่ารายการ', amount: 'menu_amount', price: 'menu_price' },
                { name: 'ค่ารายการวันอาทิตย์', amount: 'sunday_amount', price: 'sunday_price' },
                { name: 'ค่ารายการต่างจังหวัด', amount: 'province_amount', price: 'province_price' },
                { name: 'ค่ากลางคืน', amount: 'night_amount', price: 'night_price' },
                { name: 'ค่าเดินทาง (Transport)', amount: 'travel_amount', price: 'travel_price' },
                { name: 'OT', amount: 'ot_amount', price: 'ot_price' },
                { name: 'ค่าจอดปลายทาง (Destination)', amount: 'destination_amount', price: 'destination_price' },
                { name: 'ค่าที่จอดรถ (Parking fee)', amount: 'parking_amount', price: 'parking_price' },
            ],
            deductionList : [
                {name: 'ประกันสังคม (Social)',price:'insurance_price'},
                {name: 'เงินประกันการทำงาน (Work Insurance)',price:'insurance_work_price'},
                {name: 'เงินเดือนจ่ายก่อนหน้า (Pay Return)',price:'insurance_early_price'},
                {name: 'ลางาน (Leave)',price:'leave_price'},
                {name: 'ค่าใช้จ่ายอื่นๆ (Other Expenses)',price:'other_cost_price'},
                {name: 'อื่นๆ (Other)',price:'other_price'},
                {name: 'ค่าเครื่องแบบ (Uniform)',price:'uniform_price'},
                {name: 'ค่าน้ำ - ค่าไฟ (Water-Electricity Bill)',price:'bill_price'},
                {name: 'ใช้รถนอกเส้นทาง (Used Car)',price:'outway_price'},
            ],
        }
    },
    watch: {

    },
    methods: {
        printCheck(data){
            console.log("sdasd",data);
        },
        show_update_progress(id) {
            this.update_progress_modal = true;
            this.selectedSalary = this.salaryList.find((salary) => salary.id === id);
            this.status_modal_id = this.selectedSalary.claim_status_id;

            const matchingStatus = this.claimStatusList.find(status => status.id === this.selectedSalary.claim_status_id);
        },
        async update_progress() {
            await SystemService.update_all("Salary", { data: { claim_status_id: this.status_modal_id } }, this.selectedSalary.id).then(async (res) => {
            if (res) {
                this.update_progress_modal = false;
                this.init_salary_admins();
                Swal.fire("อัพเดทเรียบร้อย", "อัพเดทสถานะเรียบร้อย", "success");
            }
            });
        },
        statusCar(record){
            if (record.claim_status_id == 2) {
                return { txt: "กำลังดำเนินการ", color: "orange" };
            } else if (record.claim_status_id == 3) {
                return { txt: "จ่ายแล้ว", color: "green" };
            } else {
                return { txt: "รอดำเนินการ", color: "yellow" };
            } 
        },
        isHexColor(color) {
            return /^#[0-9A-Fa-f]{6}$/.test(color);
        },
        statusStyle(color) {
            const opacityBackground = this.hexToRgba(color, 0.3);
            const opacityBorder = this.hexToRgba(color, 0.5);
            return `border: 1px solid ${opacityBorder}; 
                    background-color: ${opacityBackground}; 
                    color: ${color};
                    display: inline-block;
                    padding: 0px 7px;
                    width: 'fit-content';
                    border-radius: 2px;
                    font-size: 12px;`;
        },
        hexToRgba(hex, alpha) {
            let r = parseInt(hex.substring(1, 3), 16);
            let g = parseInt(hex.substring(3, 5), 16);
            let b = parseInt(hex.substring(5, 7), 16);
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        },
        render_date(datetime) {
            return dayjs(datetime).format('YYYY/MM/DD')
        },
        async go_to_edit_salary(id) {
            this.$router.push(`/app/salaryAdmin/${id}`);
        },
        getApproveStatusName(status) {
            if (status == 1) {
                return 'อนุมัติ';
            } else if (status == 2) {
                return 'ไม่อนุมัติ';
            } else {
                return '';
            }
        },
        async submit_month_report() {
            this.show_month_report = false;
            this.$message.loading({ content: "\u0e01\u0e33\u0e25\u0e31\u0e07\u0e42\u0e2b\u0e25\u0e14...", key: "loading" });

            const time_start = dayjs(this.month_report.purchase_datetime[0]).format("YYYY-MM-DD");
            const time_end = dayjs(this.month_report.purchase_datetime[1]).format("YYYY-MM-DD");

            const data = this.salaryList.find((item) => {
                return item.car_company_id == this.month_report.car_company_id &&
                    item.driver_id == this.month_report.driver_id &&
                    item.month_period == this.month_report.month_period &&
                    dayjs(item.purchase_datetime).format("YYYY-MM-DD") >= time_start &&
                    dayjs(item.purchase_end_datetime).format("YYYY-MM-DD") <= time_end;
            });
            const carCompanyData = this.car_company_list.find((item) => item.id == this.month_report.car_company_id);

            const workbook = new ExcelJS.Workbook();
            const sheet = workbook.addWorksheet("PaySlip");

            const imageUrl = carCompanyData.logo;
            const response = await axios.get(imageUrl, { responseType: 'arraybuffer' });
            const imageBuffer = Buffer.from(response.data, 'binary');

            const imageId = workbook.addImage({
                buffer: imageBuffer,
                extension: 'png', 
            });

            sheet.addImage(imageId, {
                tl: { col: 1.05, row: 1.1 },
                ext: { width: 170, height: 80 },
                editAs: 'oneCell',
            });

            sheet.getCell("F2").value =  {
                richText: [
                    {
                        font: { name: "TH Sarabun New", size: 18, bold: true},
                        text: `ใบรับเงินเดือน (PAY SLIP)\n`,
                    },]
            };
            sheet.mergeCells("F2:G2");
            sheet.getCell("F2").alignment = { vertical: "middle", horizontal: "right" };
            sheet.mergeCells("F3:G5");

            function formatLine(label, value, pad = 50) {
                if(label == 'ประจำงวด (PERIOD)'){
                    pad = 53
                }
                else if(label == 'วันที่จ่าย (DATE)'){
                    pad = 58
                }else if(label == 'แผนก (Dept.)'){
                    pad = 56
                }
                return label.padEnd(pad, ' ') + value + '\n';
            }

            const richTextContent = [
                {
                    font: { name: "TH Sarabun New", size: 14 },
                    text: formatLine("ประจำงวด (PERIOD)", `${data?.month_period}`),
                },
                {
                    font: { name: "TH Sarabun New", size: 14 },
                    text: formatLine("วันที่จ่าย (DATE)", `${this.render_date(data?.purchase_datetime)} - ${this.render_date(data?.purchase_end_datetime)}`),
                },
                {
                    font: { name: "TH Sarabun New", size: 14 },
                    text: formatLine("แผนก (Dept.)", "ขับรถ"),
                },
            ];

            sheet.getCell("F3").value = { richText: richTextContent };

            sheet.getCell("F3").alignment = {
                wrapText: true,
                vertical: "middle",
                horizontal: "left",
            };
            sheet.mergeCells("B6:G6");
            sheet.getColumn(2).width = 25;
            sheet.getColumn(3).width = 15;
            sheet.getColumn(4).width = 25;
            sheet.getColumn(5).width = 8;
            sheet.getColumn(6).width = 30;
            sheet.getColumn(7).width = 25;

            // Employee Info
            sheet.addRow(["", "", data?.driver.driver_no, "", "", `${data?.driver.firstname} ${data?.driver.lastname}`]);
            sheet.mergeCells("C7:D7");
            sheet.getCell("B7").value = {
                richText: [
                    {
                        font: { name: "TH Sarabun New", size: 14, bold: true},
                        text: `รหัสพนักงาน\n`,
                    },
                    {
                        font: { name: "TH Sarabun New", size: 14, bold: true},
                        text: `Emp.Code\n`,
                    }
                ]
            };
            sheet.getCell("B7").alignment = { wrapText: true };
            sheet.getCell("E7").value = {
                richText: [
                    {
                        font: { name: "TH Sarabun New", size: 14, bold: true},
                        text: `ชื่อ\n`,
                    },
                    {
                        font: { name: "TH Sarabun New", size: 14, bold: true},
                        text: `Name\n`,
                    }
                ]
            };
            sheet.getCell("E7").alignment = { wrapText: true };
            sheet.mergeCells("F7:G7");
            // Headers
            sheet.addRow(["", "รายได้ (Income)", "จำนวน", "จำนวนเงิน","", "รายการหัก (Deduction)", "จำนวนเงิน"]);
            // Income and Deduction Details
            const maxRows = Math.max(this.incomeList.length, this.deductionList.length);
            for (let i = 0; i < maxRows; i++) {
                const income = this.incomeList[i];
                const deduction = this.deductionList[i];

                const incomeLabel = income?.name || "";
                const incomeAmount = income ? data?.[income.amount] || '-' : "-";
                const incomePrice = income && data?.[income.amount] ? data?.[income.price] || '-' : "-";

                const deductionLabel = deduction?.name || "";
                const deductionAmount = deduction ? data?.[deduction.price] || '-' : "-";

                sheet.addRow(["", incomeLabel, incomeAmount, incomePrice,"", deductionLabel, deductionAmount]);
            }

            sheet.addRow(["", "เงินได้รวม (Total Income)", "-", data?.sum_cost,"", "เงินหักรวม (Total Deduction)", data?.sum_price]);
            sheet.addRow(["", "เงินได้สุทธิ (Net Income)", "","", "", ""]);
            sheet.addRow(["","เงินได้สะสม","-",data?.consume_price,"","ประกันสังคมสะสม",data?.social_insurance_price]);
            sheet.addRow(["","ภาษีสะสม","-",data?.tax_price,"","กองทุนสำรองเลี้ยงชีพสะสม",data?.fund_price]);
            sheet.addRow([""]);
            sheet.addRow(["","","","","","ลงชื่อผู้รับเงิน/Sign...................................."]);
            sheet.addRow(["","","","","","วันที่/Date................................................"]);
            sheet.mergeCells("C32:D32")
            sheet.mergeCells("F32:G32")

            //add size and font to all exccel
            sheet.eachRow((row) => {
                row.eachCell((cell) => {
                    cell.font = {
                    name: "TH Sarabun New",
                    size: 14, // or any size you prefer
                    };
                });
            });

            sheet.getCell("C2").value = {
                richText: [
                    {
                        font: { name: "TH Sarabun New", size: 16, bold: true },
                        text: `${carCompanyData?.fullname}\n`,
                    },
                    {
                        font: { name: "TH Sarabun New", size: 16 },
                        text: `${carCompanyData?.address}\n`,
                    },
                    {
                        font: { name: "TH Sarabun New", size: 16 },
                        text: `Tel: ${carCompanyData?.phone_no || '-'} Fax: ${carCompanyData?.fax_no || '-'}\n`,
                    },
                    {
                        font: { name: "TH Sarabun New", size: 16 },
                        text: `\u0e40\u0e25\u0e02\u0e1b\u0e23\u0e30\u0e08\u0e33\u0e15\u0e31\u0e27\u0e1c\u0e39\u0e49\u0e40\u0e2a\u0e35\u0e22\u0e20\u0e32\u0e29\u0e35 ${carCompanyData?.tax_id || '-'}`,
                    }
                ]
            };
            sheet.getCell("C2").alignment = { wrapText: true, vertical: "top", horizontal: "left" };
            sheet.mergeCells("C2:E5");
            sheet.mergeCells("B2:B5");
            // Add border to relevant area
            const rowCount = sheet.rowCount;

            for (let r = 2; r <= rowCount + 1; r++) {
                for (let c = 2; c <= 7; c++) {
                    const cell = sheet.getCell(r, c);

                    if ([35, 36, 37, 38].includes(r) && !([36,37].includes(r)  && c == 6)) {
                        cell.border = {
                            ...(c === 2 ? { left: { style: "thin" } } : {}),
                            ...(c === 7 ? { right: { style: "thin" } } : {}),
                            ...(r === 38 ? { bottom: { style: "thin" } } : {}),
                        };
                    } else if (c == 5 && r >= 8 && r <= 34){
                        cell.border = {};
                    }else {
                        cell.border = {
                            top: { style: "thin" },
                            bottom: { style: "thin" },
                            left: { style: "thin" },
                            right: { style: "thin" },
                        };
                    }
                }
            }

            const boldRow7 = sheet.getRow(7); // adjust the number based on your sheet
            boldRow7.eachCell((cell, colNumber) => {
                cell.font = {
                    name: "TH Sarabun New",
                    size: 14,
                    bold: true,
                };
                // Columns C (3), D (4), F (6), G (7)
                if ([3, 4, 6, 7].includes(colNumber)) {
                    cell.alignment = {
                        wrapText: true,
                        vertical: "middle",
                        horizontal: "center",
                    };
                } else {
                    cell.alignment = {
                        wrapText: true,
                        vertical: "top",
                        horizontal: "center",
                    };
                }
            });
            const boldRow8 = sheet.getRow(8); // adjust the number based on your sheet
            boldRow8.eachCell((cell) => {
                cell.font = {
                    name: "TH Sarabun New",
                    size: 14,
                    bold: true,
                };
                cell.alignment = { 
                    wrapText: true, 
                    vertical: "top", 
                    horizontal: "center",
                };
            });

            const boldRow31 = sheet.getRow(31); 
            boldRow31.eachCell((cell) => {
                cell.font = {
                    name: "TH Sarabun New",
                    size: 14,
                    bold: true,
                };
            });
            const boldRow32 = sheet.getRow(32); 
            boldRow32.eachCell((cell) => {
                cell.font = {
                    name: "TH Sarabun New",
                    size: 14,
                    bold: true,
                };
            });
            const boldRow33 = sheet.getRow(33); 
            boldRow33.eachCell((cell) => {
                cell.font = {
                    name: "TH Sarabun New",
                    size: 14,
                    bold: true,
                };
            });
            const boldRow34 = sheet.getRow(34); 
            boldRow34.eachCell((cell) => {
                cell.font = {
                    name: "TH Sarabun New",
                    size: 14,
                    bold: true,
                };
            });

            sheet.getCell("C32").value = {
                richText: [
                    {
                        font: { name: "TH Sarabun New", size: 14, bold: true },
                        text: `${data?.total_price}\n`,
                    },
                ]
            };
            sheet.getCell("C32").alignment = { wrapText: true, vertical: "top", horizontal: "right" };

            sheet.getRow(3).height = 70;
            sheet.getRow(7).height = 60;
            sheet.getRow(8).height = 30;

            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer]), `PaySlip_${data?.driver.firstname}_${data?.month_period}.xlsx`);
            this.$message.success({ content: "โหลดข้อมูลสำเร็จ", key: "loading" });
        },
        remove_leave_user(id){
            Swal.fire({
                title: 'คุณต้องการลบใช่หรือไม่??',
                text: `คุณจะไม่สามารถกู้คืนได้`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ใช่',
                cancelButtonText: 'ยกเลิก'
                }).then(async (result) => {
                if (result.isConfirmed) {
                    await SystemService.delete_all('Salary', id)
                    this.onRefresh()
                }
            })
        },
        showLeaveDetails(record) {
            this.selectedLeave = record;
            this.showModalLeaveUserData = true;
        },
        onRefresh() {
             this.init_salary_admins()
        },
        clear_search() {
            this.search_input = null;
            this.timeStart = null;
            this.timeEnd = null;
        },
        filtered_list(array) {
            return array.filter(({ fullname, time_start, time_end }) => {
                let matchesName = true;
                let matchesDateRange = true;
                if (this.search_input) {
                    matchesName = fullname ? fullname.toLowerCase().includes(this.search_input.toLowerCase()) : false;
                }
                // ตรวจสอบช่วงวันที่ (ไม่สนใจเวลา)
                if (this.timeStart) {
                    const filterStart = dayjs(this.timeStart[0]).startOf('day');
                    const filterEnd = dayjs(this.timeStart[1]).endOf('day');
                    const target = dayjs(time_start);
                    matchesDateRange = target.isSameOrAfter(filterStart) && target.isSameOrBefore(filterEnd);
                }
                return matchesName && matchesDateRange;
            });
        },
        async init_salary_admins() {
            try {
                this.salaryList = await SalaryService.getSalaryAll()
                this.periodList = [...new Set(this.salaryList.map(item => item.month_period))];
            } catch (error) {
                console.error('Error initializing leave admins:', error);
            }
        },


        async get_company() {
            try {
                const company = await UserService.get_user_profile();
                const businessType = await CompanyService.getBusinessId(company.company_id);
                this.businessTypeId = businessType.data;
                if (businessType.data === 2 || businessType.data === 3 || businessType.data === 4) {
                    this.business = true;
                }

            } catch (error) {
                console.error("Error in get_company:", error);
            }
        },
        async getBusinessType(){
            const company = await UserService.get_user_profile();
            const businessType = await CompanyService.getBusinessId(company.company_id)
            this.businessTypeId = businessType.data
        },
        async getStatus(){
            this.leaveStatus = await SystemService.get_all('WorkStatus');
            let claimStatusFetch = await SalaryService.getClaimStatusAll();
            this.claimStatusList = claimStatusFetch.data;
            this.car_company_list = await SystemService.get_all('CarCompany');
            this.driver_list = await DriverService.getDriverByCompany();
        },
    },
    computed: {
        render_type() {
            return this.$route.params.type
        },

        filteredColumns() {
            if (Array.isArray(this.columns)) {
                return this.columns.filter(column => {
                    if(this.businessTypeId != 3 && this.businesssTypeId != 2){
                        return column.key !== 'leave_pattern_id'
                    }
                    return column.key !== 'leave_quota' || this.business;
                });
            }
            return [];
        
         },
         leave_quota_limits() {
            return this.businessTypeId === 4
                ? {
                    1: 7,  // ลากิจ: 7 ครั้ง/ปี
                    2: 12,  // ลาพักร้อน: 12 ครั้ง/ปี
                    4: 30, // ลาป่วย: 30 ครั้ง/ปี
                    6: null, // ลาชาปนกิจ: ไม่มีเงื่อนไข
                }
                : {
                    1: 3,  // ลากิจ: 3 ครั้ง/ปี
                    2: 8,  // ลาพักร้อน: 8 ครั้ง/ปี
                    7: 4,  // ลาฝึกอบรม: 4 ครั้ง/ปี
                    4: 30, // ลาป่วย: 30 ครั้ง/ปี
                    5: null, // ลาแบบไม่รับค่าจ้าง: ไม่มีเงื่อนไข
                    6: null, // ลาชาปนกิจ: ไม่มีเงื่อนไข
                };
        },
    },
    async mounted() {
        await this.getBusinessType();
        await this.getStatus();
        this.init_salary_admins().then(() => {
            this.get_company()

        });
    }
}
</script>

<style>
.preview-icon,
.download-icon {
    cursor: pointer;
    font-size: 20px;
    color: black;
}
.image-container {
    position: relative;
    display: inline-block;
}
.uploaded-image-table {
    display: block;
    width: 15rem;
    height: auto;
}
.icon-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    padding: 5px;
}

.permission-table .ant-table-row-level-0 td:first-child,
.permission-table .ant-table-row-level-0 td:nth-child(2),
.permission-table .ant-table-row-level-0 td:nth-child(3) {
    background-color: #f9f9f9 !important;
}
.permission-table .ant-table-row-expand-icon::before,
.permission-table .ant-table-row-expand-icon::after 
{
    content: '' !important;
    border: none !important;
    background: none; /* ปิด background */
    transform: none !important;
    transition: none !important;
    top: auto !important
}
.permission-table .ant-table-row-expand-icon:not(.ant-table-row-expand-icon-expanded)::before {
    content: '>' !important;
}

.permission-table .ant-table-row-expand-icon.ant-table-row-expand-icon-expanded::before {
    content: 'v' !important;
}
</style>